module.exports = __webpack_public_path__ + "../resources/images/emptyMentions-c9046294258681e2639140115f92c519.svg";